"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleOwnership$ = exports.TitleOwnership$outboundSchema = exports.TitleOwnership$inboundSchema = void 0;
exports.titleOwnershipToJSON = titleOwnershipToJSON;
exports.titleOwnershipFromJSON = titleOwnershipFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const ownershipcompany_js_1 = require("./ownershipcompany.js");
/** @internal */
exports.TitleOwnership$inboundSchema = z.object({
    companies: z.nullable(z.array(ownershipcompany_js_1.OwnershipCompany$inboundSchema)),
    company_owned: z.boolean(),
    overseas_owned: z.boolean(),
    social_housing: z.boolean(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "company_owned": "companyOwned",
        "overseas_owned": "overseasOwned",
        "social_housing": "socialHousing",
    });
});
/** @internal */
exports.TitleOwnership$outboundSchema = z.object({
    companies: z.nullable(z.array(ownershipcompany_js_1.OwnershipCompany$outboundSchema)),
    companyOwned: z.boolean(),
    overseasOwned: z.boolean(),
    socialHousing: z.boolean(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        companyOwned: "company_owned",
        overseasOwned: "overseas_owned",
        socialHousing: "social_housing",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var TitleOwnership$;
(function (TitleOwnership$) {
    /** @deprecated use `TitleOwnership$inboundSchema` instead. */
    TitleOwnership$.inboundSchema = exports.TitleOwnership$inboundSchema;
    /** @deprecated use `TitleOwnership$outboundSchema` instead. */
    TitleOwnership$.outboundSchema = exports.TitleOwnership$outboundSchema;
})(TitleOwnership$ || (exports.TitleOwnership$ = TitleOwnership$ = {}));
function titleOwnershipToJSON(titleOwnership) {
    return JSON.stringify(exports.TitleOwnership$outboundSchema.parse(titleOwnership));
}
function titleOwnershipFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.TitleOwnership$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'TitleOwnership' from JSON`);
}
//# sourceMappingURL=titleownership.js.map